import { createContext } from 'react';

export type AppraisalListContextType = {
  removeAppraisal: (appraisalId: string) => void;
};

export const AppraisalListContext = createContext<AppraisalListContextType>({
    removeAppraisal: () => null,
});
